(function () {
    'use strict';
    angular.module('LoginModule', ['ui.router', 'ngStorage', 'toastr'])
        .service("config", function ($window, $location) {
            this.URL = window.URL_APP;
            this.URL_STUDENT_APP = window.URL_STUDENT_APP;
            this.API_USER_MANAGEMENT = window.API_USER_MANAGEMENT;
        })
        .config(routeConfig)
        .config(toastrLibConfig)
        .factory('LoginSvc', function ($http, config) {
            return {
                login: function (data) {
                    var url = config.API_USER_MANAGEMENT + 'login';
                    return $http.post(url, data)
                },
                reset: function (data) {
                    var url = config.API_USER_MANAGEMENT + "reset-password";
                    return $http.post(url, data);
                },
            };
        })
        .controller('LoginCtrl', xxx);
        function routeConfig(
            $httpProvider,
            $localStorageProvider
        ) {
            $httpProvider.interceptors.push(function ($q,toastr) {
                return {
                    'responseError': function (res) {
                        if (res.data && res.data.ErrorCode) {
                            if (res.data.ErrorCode == 1) {
                                for (var i = 0; i < res.data.ValidationErrors.length; i++) {
                                    toastr.error(res.data.ValidationErrors[i].ErrorMessage);
                                }
                            } else {
                                toastr.error(res.data.Message);
                            }
                        }else if(res.status == -1){
                            toastr.error("Koneksi Internet Terputus");
                        } else {
                            toastr.error(res.statusText);
                        }
                        return $q.reject(res);
                    }
                };
            });
        }
    /** @ngInject */
    function toastrLibConfig(toastrConfig) {
        angular.extend(toastrConfig, {
            "autoDismiss": false,
            "positionClass": "toast-top-center",
            "timeOut": "1000",
            "allowHtml": false,
            "closeButton": true,
            "tapToDismiss": false,
            "newestOnTop": true,
            "maxOpened": 0,
            "preventDuplicates": false,
            "preventOpenDuplicates": false
        });
    }
    /** @ngInject */
    function xxx($scope, $localStorage, $window, toastr,config, LoginSvc) {
        $scope.form = {}
        $scope.ApplicationId = "6a3e4d8e-2b8b-4c23-948e-af06b6ec18fd";
        $scope.urlStudentApp = config.URL_STUDENT_APP;
        $scope.$storage = $localStorage;
        $scope.sessionStatus = $window.location.href.split("&sessionexpired=")
        $scope.messageSent == false
        $scope.isOriginEmpty = false
        $scope.showPassword = false;
        $scope.showPasswordOrNot = function(){
            $scope.showPassword = !$scope.showPassword
        }
        $scope.checkAuthKey = function(){
            var searchParams = new URLSearchParams(window.location.search);
            var sessionexpired = searchParams.get('sessionexpired');
            if (sessionexpired == 'true') {
                $localStorage.$reset();
            } else {
                if ($localStorage.AuthKey != undefined) {
                    $window.location.href = $scope.urlStudentApp + '?AuthKey=' + $localStorage.AuthKey
                }
            }
        }
        $scope.checkAuthKey();
        $scope.login = function () {
            $scope.isLoading = true;
            $scope.form.ApplicationId = $scope.ApplicationId;
            LoginSvc.login($scope.form).then(function (res) {
                if (res.data.ErrorCode !== 0) {
                    $scope.isLoading = false;
                    toastr.error(res.data.Message);
                } else {
                    $localStorage.isLogin = true;
                    $localStorage.AuthKey = res.headers("AuthKey")
                    toastr.success(res.data.Message);
                    $scope.isLoading = false;
                    $window.location.href = $scope.urlStudentApp + '?AuthKey=' + res.headers("AuthKey");
                }
            }).catch(function(e){
                $scope.isLoading = false;
            })
        }
        $scope.ResetPassword = function () {
            $scope.isLoading = true;
            LoginSvc.reset($scope.form.email).then(function (res) {
                if (res.data.ErrorCode !== 0) {
                    $scope.isLoading = false;
                    toastr.error(res.data.Message.split('|')[0]);
                } else {
                    toastr.success(res.data.Message);
                    $scope.isLoading = false;
                    $scope.messageSent = true
                }
            }).catch(function(e){
                $scope.isLoading = false;
            })
        }
    }
})();
